import cn from 'classnames';
import Plyr, {
  APITypes,
} from 'plyr-react';
import {
  memo, useId, useMemo, useRef, useState,
} from 'react';

import PlayIcon from '../SVGIcons/PlayIcon';
import classes from './video-player.module.scss';

interface IVideoPlayerProps {
  link: string;
  poster?: string;
  order: number;
}

function VideoPlayer({ link, poster, order }: IVideoPlayerProps) {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const videoRef = useRef<APITypes | null>(null);
  const uniqueId = useId();

  const memoPlyr = useMemo(() => (
    <Plyr
      id={uniqueId}
      ref={videoRef}
      options={{
        loop: {
          active: true,
        },
        hideControls: true,
        controls: isVideoPlaying ? [
          'play',
          'progress',
          'current-time',
          'duration',
          'mute',
          'volume',
          'fullscreen',
        ] : [],
      }}
      source={{ type: 'video', poster, sources: [{ src: link }] }}
    />
  ), [uniqueId, isVideoPlaying, link]);
  return (
    <div className={classes.videoContainer} style={{ order }}>
      {memoPlyr}
      <div
        className={cn({
          [classes.videoOverlay]: true,
          [classes.hidden]: isVideoPlaying,
        })}
      >
        <div
          role="none"
          onClick={() => {
            setIsVideoPlaying(true);
            setTimeout(() => videoRef.current!.plyr.play(), 1);
          }}
          className={cn({
            [classes.playButton]: true,
          })}
        >
          <PlayIcon />
        </div>
      </div>
    </div>
  );
}

export default memo(VideoPlayer);
